/**
 * @graphql cc
 */
import gql from 'graphql-tag';

export const waitForEditionChangeQuery = gql`
	query waitForEditionChangeQuery {
		tenant: confluence_tenantContext {
			editions {
				confluence
			}
		}
	}
`;
